import type { Observable } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { NotificationMessageComponent } from '@components/atoms/notification-message/notification-message.component';
import {
	type NotificationData,
	NotificationService
} from '@components/molecules/notification-list/services/notification.service';

@Component({
	selector: 'm-notification-list',
	templateUrl: './notification-list.component.html',
	styleUrls: ['../../../styles/7-molecules/_notification-list.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, NotificationMessageComponent],
	providers: []
})
export class NotificationListComponent {
	private readonly notificationService: NotificationService = inject(NotificationService);

	protected notifications$: Observable<NotificationData[]> =
		this.notificationService.notifications$;

	notificationClosed(id: string) {
		this.notificationService.removeNotification(id);
	}
}
